import {
  Button,
  Card,
  CardHeader,
  CircularProgress,
  Tooltip,
  Typography,
} from '@material-ui/core';
import Role from 'App/Vehicles/shared/Role';
import queryString from 'query-string';
import React from 'react';
import { Link, RouteComponentProps, withRouter } from 'react-router-dom';
import styled from 'styled-components';

import useCustomerUsers from 'core/hooks/useCustomerUsers';
import { useSchemaMeta } from 'Elements/Form/Schema';
import {
  Body,
  Column,
  GridTable,
  Header,
  Row as GridRow,
} from 'Elements/GridTable';
import LinkRow from 'Elements/GridTable/LinkRow';

const Row = styled(GridRow)`
  grid-template-columns: 150px auto;
`;

const CenterColumn = styled(Column)`
  grid-column: 1 / -1;
  display: flex;
  justify-content: center;
`;

function CustomerUsersTable({ location }: RouteComponentProps) {
  const { customerId } = useSchemaMeta<{ customerId: number }>();
  const { users, loading } = useCustomerUsers(customerId);

  return (
    <Card elevation={1}>
      <CardHeader
        title={
          <Tooltip
            title="Kirjautuminen Rengastalli mobiilisovellukseen"
            placement="right"
          >
            <span>Käyttäjät</span>
          </Tooltip>
        }
        action={
          <Button
            variant="contained"
            color="primary"
            size="small"
            component={Link}
            to={{
              pathname: `/users/create`,
              search: queryString.stringify({
                role_id: 'customer',
                customer_id: customerId,
                redirect: location.pathname
              })
            }}
            disabled={!customerId}
          >
            Lisää uusi
          </Button>
        }
      />
      <GridTable>
        <Header>
          <Row>
            <Column>Rooli</Column>

            <Column>Nimi</Column>
          </Row>
        </Header>

        <Body>
          {users.map(user => (
            <LinkRow to={'/users/' + user.id} key={user.id}>
              <Row hover>
                <Column>
                  <Role id={user.role_id} />
                </Column>
                <Column>{user.full_name}</Column>
              </Row>
            </LinkRow>
          ))}

          {users.length === 0 && (
            <Row>
              <CenterColumn>
                {loading && <CircularProgress />}

                {!loading && users.length === 0 && (
                  <Typography variant="subtitle1">
                    Asiakkaalla ei ole käyttäjiä
                  </Typography>
                )}
              </CenterColumn>
            </Row>
          )}
        </Body>
      </GridTable>
    </Card>
  );
}

export default withRouter(CustomerUsersTable);
